<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :full-screen="true"
  >
    <template slot="header">
      <v-row class="align-center">
        <v-col cols="auto">
          <span
              v-if="item"
              style="font-size: 30px; font-weight: 500; color: #000000;"
          >Job: {{ item.wo_number }} - {{ item.project }}; {{ item.project_floor }}</span>
        </v-col>
        <v-col cols="auto" class="text-end">
            <span style="font-size: 30px; font-weight: 500; color: #000000;">Total Items: {{ items.length }}</span>
        </v-col>
        <v-spacer />
        <v-col
          cols="auto"
          class="pb-0 pt-0"
        >
          <v-row class="align-center">
            <v-col class="pr-2 pt-4">
              <span :style="{color: isDarkMode ? '#ffffffb3' : '#00000099', fontSize: '16px !important'}">Decimal</span>
            </v-col>
            <v-col
              class="pl-0"
              cols="auto"
            >
              <v-switch
                v-model="uomSwitch"
                hide-details
                label="Fraction"
                class="mt-0"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template slot="body">
      <v-row>
        <v-col>
          <v-card
            elevation="0"
            outlined
          >
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              :loading="loading"
              :items-per-page="-1"
              dense
            >
              <template #[`item.class`]="{ item }">
                <v-chip
                  small
                  :color="item && item.class ? item.class.color : 'black'"
                  text-color="white"
                >
                  {{ item && item.class ? item.class.name : '' }}
                </v-chip>
              </template>
              <template #[`item.job`]="{ item }">
                <span>
                  <span style="font-weight: bold;"><text-highlight :queries="search">{{ item.job_code ? `${item.job_code}` : '' }}</text-highlight></span> - <text-highlight :queries="search">{{ item.job_name ? item.job_name : item.job_name }}</text-highlight> <span style="color: #1976D2;"><text-highlight :queries="search">{{ item.job_reference ? `; ${item.job_reference}` : '' }}</text-highlight></span>
                </span>
              </template>
              <template #[`item.tag_number`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.tag_number ? item.tag_number : '-' }}
                </text-highlight>
              </template>
             <template #[`item.type`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.type ? item.type.code : '-' }}
                </text-highlight>
              </template>
             <template #[`item.description`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.type ? item.type.description : '-' }}
                </text-highlight>
              </template>
              <template #[`item.color`]="{ item }">
                <text-highlight :queries="search">
                  {{ item && item.color ? item.color.code && item.color.name ? `${item.color.code} ${item.color.name}` : item.color.code : '-' }}
                </text-highlight>
              </template>
              <template #[`item.length`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.length ? (uomSwitch ? convertToFraction(item.length) : item.length) : '-' }}
                </text-highlight>
              </template>
              <template #[`item.width`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.width ? (uomSwitch ? convertToFraction(item.width) : item.width) : '-' }}
                </text-highlight>
              </template>
              <template #[`item.height`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.height ? (uomSwitch ? convertToFraction(item.height) : item.height) : '-' }}
                </text-highlight>
              </template>
              <template #[`item.sqft`]="{ item }">
                <text-highlight :queries="search">
                  {{ item.sqft ? item.sqft : '' }}
                </text-highlight>
              </template>
              <template #[`item.location`]="{ item }">
                <text-highlight :queries="search">
                  {{ item && item.location ? item.location.name : '' }} {{ item && item.shelf ? `; ${item.shelf.name }`: '' }}
                </text-highlight>
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip
                  small
                  style="width: 100%; max-width: 140px; white-space: nowrap; "
                  :color="item && item.status ? item.status.color : 'black'"
                  text-color="white"
                >
                  {{ item && item.status ? item.status.name : '' }}
                </v-chip>
              </template>
              <!-- <template #[`item.updated_at`]="{ item }">
                {{ item ? convertDateFormat(item.updated_at) : '' }}
              </template> -->
              <template #[`item.updated_at`]="{ item }">
                <v-tooltip
                  bottom
                  color="black"
                >
                  <template #activator="{ on }">
                    <span
                      @mouseover="getWipPanelsHistory(item)"
                      v-on="on"
                    >{{ item ? convertDateFormat(item.updated_at) : '' }}</span>
                  </template>

                  <div
                    :style="`${loadingHistory ? 'text-align: center; width: 500px;' : 'width: 500px;'}`"
                    :class="`${loadingHistory ? '' : 'pt-3'}`"
                  >
                    <span v-if="loadingHistory">Loading History...</span>
                    <p
                      v-else
                      v-for="history in wipPanelHistories"
                      :key="history.id"
                    >
                      <span v-if="history.status_id == glassStatusIdCutting">{{ `Cut At: ${history.created_at} - Cut By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdProduced">{{ `Produced At: ${history.created_at} - Produced By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdShipped">{{ `Shipped At: ${history.created_at} - Shipped By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdReceived">{{ `Received At: ${history.created_at} - Received By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdCanceled">{{ `Canceled At: ${history.created_at} - Canceled By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdRejected">{{ `Rejected At: ${history.created_at} - Rejected By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdShipedToSite">{{ `Shipped To Site At: ${history.created_at} - Shipped To Site By: ${history.user_full_name}` }}</span>
                      <span v-if="history.status_id == glassStatusIdReceivedOnSite">{{ `Received On Site At: ${history.created_at} - Received On Site By: ${history.user_full_name}` }}</span>
                    </p>
                  </div>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
  },
  props: {
  },
  data: () => ({
    items: [],
    // headers: [
    //   {   
    //     text: 'Class', value: 'class', align: 'center',
    //   },
    //   { text: 'ID', value: 'id', align: 'center' },
    //   { text: 'Tag#', value: 'tag_number' },
    //   { text: 'Work Order', value: 'work_order' },
    //   { text: 'Panel Code/Type', value: 'type' },
    //   { text: 'Description', value: 'description' },
    //   { text: 'Color', value: 'color' },
    //   { text: 'Width', value: 'width' },
    //   { text: 'Height', value: 'height' },
    //   { text: 'Sqft', value: 'sqft' },
    //   { text: 'Status', value: 'status', align: 'center' },
    //   { text: 'Updated At', value: 'updated_at', align: 'end' },
    // ],
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    item: null,
    statusIds: [],
    loading: false,
    uomSwitch: false,
    total: 0,
    noteTypeIdWipPanel: 9,
    // statusId: null,
    wipPanelHistories: [],
    loadingHistory: false,

    glassStatusIdNew: 1,
    glassStatusIdProduced: 3,
    glassStatusIdCanceled: 4,
    glassStatusIdRemake: 5,
    glassStatusIdShipped: 6,
    glassStatusIdReceived: 7,
    glassStatusIdCutting: 10,
    glassStatusidTempering: 11,
    glassStatusIdShipedToSite: 12,
    glassStatusIdReceivedOnSite: 13,
    glassStatusIdIssued: 17,
    glassStatusIdRejected: 16,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
      isStatusReceivedShippedToSiteOrReceivedOnSite() {
        return this.statusIds.includes(this.glassStatusIdReceived) || this.statusIds.includes(this.glassStatusIdReceivedOnSite) || this.statusIds.includes(this.glassStatusIdShipedToSite);
      },
      headers() {
        const headers = []

        headers.push({ text: 'Class', value: 'class', align: 'center' })
        headers.push({ text: 'ID', value: 'id', align: 'center' })
        headers.push({ text: 'Tag#', value: 'tag_number' })
        headers.push({ text: 'Work Order', value: 'work_order' })
        headers.push({ text: 'Panel Code/Type', value: 'type' })
        headers.push({ text: 'Description', value: 'description' })
        headers.push({ text: 'Color', value: 'color' })
        headers.push({ text: 'Length', value: 'length' })
        headers.push({ text: 'Width', value: 'width' })
        headers.push({ text: 'Height', value: 'height' })
        headers.push({ text: 'Sqft', value: 'sqft' })
        if (this.isStatusReceivedShippedToSiteOrReceivedOnSite) {
          headers.push({ text: 'Received Location', value: 'location', align: 'center' })
        }
        headers.push({ text: 'Status', value: 'status', align: 'center' })
        headers.push({ text: 'Updated At', value: 'updated_at', align: 'end' })

        return headers
      },
    }),
  },
  methods: {
    init() {
    },

    async get(item, statusIds) {
      this.loading = true;
      this.items = [];
      this.total = 0;
      const submitModel = {
        filters: {
          wip_panel_schedule_id: item.id,
          status_ids: statusIds,
          is_all: 1,
        },
      };
      const res = await this.$api.wipPanel.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.total = 0;
        return;
      }
      this.items = res.data;
      this.total = res.total;
    },

    open(item, statusIds) {
      this.item = item;
      this.statusIds = statusIds;
      this.get(item, statusIds);
      this.$refs.dialogBox.open();
    },

    openNoteForm(itemId) {
      this.$refs.noteForm.open(itemId, this.noteTypeIdWipPanel);
    },

    async getWipPanelsHistory(item) {
      this.loadingHistory = true;

      const submitModel = {
        filters: { id: item.id },
      };
      const res = await this.$api.wipPanelHistory.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return '';
      if (!res) {
        this.wipPanelHistories = [];
        this.loadingHistory = false;
        return '';
      }
      this.wipPanelHistories = res;
      this.loadingHistory = false;
      return '';
    },

    convertToFraction(decimal) {
      const fractions = {
        0.0625: '1/16',
        0.125: '1/8',
        0.1875: '3/16',
        0.25: '1/4',
        0.3125: '5/16',
        0.375: '3/8',
        0.4375: '7/16',
        0.5: '1/2',
        0.5625: '9/16',
        0.625: '5/8',
        0.6875: '11/16',
        0.75: '3/4',
        0.8125: '13/16',
        0.875: '7/8',
        0.9375: '15/16',
      };

      // If the decimal is an exact match to any fraction, return the fraction directly
      if (decimal in fractions) {
        return fractions[decimal];
      }

      const wholeNumber = Math.floor(decimal);
      // eslint-disable-next-line no-param-reassign
      decimal -= wholeNumber; // Remove the whole number part

      let closestFraction = Object.keys(fractions)[0];

      // eslint-disable-next-line no-restricted-syntax
      for (const fraction of Object.keys(fractions)) {
        if (Math.abs(decimal - fraction) < Math.abs(decimal - closestFraction)) {
          closestFraction = fraction;
        }
      }

      if (wholeNumber > 0) {
        return `${wholeNumber} - ${fractions[closestFraction]}"`;
      }
      return fractions[closestFraction];
    },

    convertDateFormat(inputDate) {
      // Parse the input date
      const date = new Date(inputDate);

      // Format the date as "YYYY-MM-DD h:mm a" (e.g., 2023-10-24 9:25 PM)
      const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      return formattedDate;
    },

  },
}
</script>

<style scoped>
</style>